// Typed accessor over the check-in queue cadence copy. Mirrors the metrics
// glossary precedent (see metrics/metricsGlossary.ts): the JSON is the single
// source of truth, this module gives it a type, and every renderer prints the
// strings verbatim rather than paraphrasing them.
import cadence from './queueCadence.json';

export interface CadenceEntry {
  key: string;
  heading: string;
  body: string;
}

export const QUEUE_CADENCE_TITLE: string = cadence.title;

export const QUEUE_CADENCE_ENTRIES: CadenceEntry[] = cadence.entries;

export type CadenceKey = (typeof cadence.entries)[number]['key'];

/** One entry by key, or null so a missing key degrades to "render nothing"
 * rather than crashing the page (same contract as getMetricInfo). */
export const getCadenceEntry = (key: string): CadenceEntry | null =>
  QUEUE_CADENCE_ENTRIES.find((entry) => entry.key === key) ?? null;

export default QUEUE_CADENCE_ENTRIES;
